"use client";

import { usePathname } from "next/navigation";

/**
 * True for the gated, full-screen course workspace, e.g.
 * /courses/ai-fundamentals-for-business/learn
 */
export function isWorkspaceRoute(pathname: string | null): boolean {
  return !!pathname && /^\/courses\/[^/]+\/learn(?:\/|$)/.test(pathname);
}

/**
 * Hides the marketing chrome (header and footer) on the course workspace, which
 * is a focused, signed-in app experience with its own minimal top bar. Showing
 * the public marketing header there is contradictory (it offers "Sign in" to an
 * already-signed-in learner). Children render on every other route.
 */
export function HideOnWorkspace({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  if (isWorkspaceRoute(pathname)) return null;
  return <>{children}</>;
}
